import React from 'react'
import { useTranslation } from 'react-i18next'

import { SectionLinks } from '@src/types/navigation'

import MobileMenuLink from '../MobileMenuLink'

type Props = {
  section: SectionLinks
}

export default function MobileSectionLinks({ section }: Props) {
  const { t } = useTranslation('revamp')
  return (
    <section className='flex flex-col gap-8'>
      {section.link ? (
        <MobileMenuLink title={section.title} href={section.link} />
      ) : (
        <p className={'font-bold flex items-center w-full leading-mid text-xl'}>{section.title}</p>
      )}
      {section.items.map((item) => (
        <MobileMenuLink
          key={`mobile_training_tab_${section.title}_${item.title}`}
          title={item.title}
          href={item.link}
          font='normal'
        />
      ))}
      {section.viewMoreLink && (
        <MobileMenuLink title={t('viewMore')} href={section.viewMoreLink} font='bold' />
      )}
    </section>
  )
}
